import { createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from 'jwt-decode';
import dateToString_ISO from '../../util/converterDate'

export const userSlice = createSlice({
    name: 'userLogged',
    initialState : {
        authenticated: false,
        userLogged: null,
        token: null,
        profilePhoto: null,
        isFullProfile: true,
        isFirstAccess: false
    },
    reducers: {
        setIsFirstAccess: (state, action) => {
            state.isFirstAccess = action.payload;
        },
        setIsFullProfile: (state, action) => {
            state.isFullProfile = action.payload;
        },
        setProfilePhoto: (state, action) => {
            state.profilePhoto = 
                action.payload !== '' && action.payload !== undefined
                    ? action.payload
                    : '/assets/img/generic/no-user.png';
        },
        setAuthenticated: (state, action) => {
            if (action.payload === null){
                state.authenticated = false;
                state.userLogged = null;
                state.token = null;
            }
            else{
                const decodedToken = jwtDecode(action.payload);
                const minutesExpiration = parseInt(decodedToken["http://schemas.microsoft.com/ws/2008/06/identity/claims/expiration"]);
                const dateExpiration = new Date(
                    new Date().getTime() + (minutesExpiration * 60 * 1000)
                );
                const stringDateExpiration = dateToString_ISO(dateExpiration);
                const googleAuthenticated = decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata'] === 'true' ? true : false;

                state.token = action.payload;
                state.authenticated = true;
                state.userLogged = {
                    userId: decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid'],
                    name: decodedToken.unique_name,
                    email: decodedToken.email,
                    role: decodedToken.role,
                    expiration: stringDateExpiration,
                    googleAuthenticated: googleAuthenticated
                }
            }
        }
    }
})

export const { 
    setAuthenticated,
    setProfilePhoto,
    setIsFullProfile,
    setIsFirstAccess,
} = userSlice.actions;